import { render, staticRenderFns } from "./office-access.vue?vue&type=template&id=578e0680&"
import script from "./office-access.vue?vue&type=script&lang=js&"
export * from "./office-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports